import { Entity } from "../helpers/Entity"
import { TOOGGLE_DESCRIPTION_TYPE } from "../pricing/ProductDescription"
import NotificationSettings from "./NotificationSettings"
import SignatureSettings from "./SignatureSettings"

export type PreferenceAttributesDto = {
    notificationSettings: NotificationSettings
    signatureSettings: SignatureSettings
    productDescription: TOOGGLE_DESCRIPTION_TYPE
    bottomPriceEnabled: boolean
}

export type PreferenceDto = {
    id: string
    type: string
    attributes: PreferenceAttributesDto
}

export default class Preference implements Entity {
    private dto: PreferenceDto
    constructor(dto: PreferenceDto) {
        this.dto = dto
    }

    isLoaded(): boolean {
        return this.dto.id != "" && this.dto.type == "user-preferences"
    }

    getId(): string {
        return this.dto.id
    }

    getNotificationSettings(): NotificationSettings {
        return new NotificationSettings(this.dto.attributes.notificationSettings)
    }

    getSignatureSettings(): SignatureSettings {
        return new SignatureSettings(this.dto.attributes.signatureSettings)
    }

    getSignatureLogoUrl(): string {
        return this.dto.attributes.signatureSettings.logoUrl
    }

    getSignatureIsEnable(): boolean {
        return this.dto.attributes.signatureSettings.isEnable
    }

    getSignatureLogoId(): string {
        return this.dto.attributes.signatureSettings.signatureLogoId
    }

    getSignature(): string {
        return this.dto.attributes.signatureSettings.signature
    }

    isBottomPriceEnabled(): boolean {
        return this.dto.attributes.bottomPriceEnabled
    }

    getPreApprovedQuote(): boolean {
        return this.dto.attributes.notificationSettings.preApprovedQuote
    }

    getQuoteCreatedPriceList(): boolean {
        return this.dto.attributes.notificationSettings.quoteCreatedPriceList
    }

    getInvoiceCreatedPriceList(): boolean {
        return this.dto.attributes.notificationSettings.invoiceCreatedPriceList
    }

    getPreDeclinedQuote(): boolean {
        return this.dto.attributes.notificationSettings.preDeclinedQuote
    }

    getSentPayment(): boolean {
        return this.dto.attributes.notificationSettings.sentPayment
    }

    getNewConversation(): boolean {
        return this.dto.attributes.notificationSettings.newConversation
    }

    getNewSms(): boolean {
        return this.dto.attributes.notificationSettings.newSms
    }

    getDocumentSigned(): boolean {
        return this.dto.attributes.notificationSettings.signedDocument
    }

    getOpenedQuote(): boolean {
        return this.dto.attributes.notificationSettings.openedQuote
    }

    getOrderAssigned(): boolean {
        return this.dto.attributes.notificationSettings.orderAssigned
    }

    getOrderLineAssigned(): boolean {
        return this.dto.attributes.notificationSettings.orderLineAssigned
    }
}



// WEBPACK FOOTER //
// ./src/state/user/Preference.ts